// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__35yuc","header":"ReportDetails_header__265To","title":"ReportDetails_title__12yex","left":"ReportDetails_left__k-3TB"};